<template>
  <div class="confirmDialog">
    <el-dialog v-model="showDialog" width="380px" :before-close="closeDialog" center :show-close="false">
      <div class="content-wrapper">
        <img src="@/assets/img/common/warning.png" alt="" />
        <div>
          <div class="title">确认要删除该模版吗？</div>
          <div class="text">删除后将不能恢复。如有需要，您可重新提交模板</div>
          <div> </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn cancel" @click="closeDialog">取 消</div>
        <div class="btn" @click="confirm">确 认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { applicantDel } from "@/server/applicant";
export default {
  data() {
    return {
      showDialog: false,
      id: "",
    }
  },
  created() {
  },
  methods: {
    // 初始化数据
    init(id) {
      this.id = id;
      this.showDialog = true;
    },
    confirm() {
      this.applicantDel();
    },
    // 申请主体删除
    async applicantDel() {
      await applicantDel({applicantIde: this.id});
      this.$message.success("操作成功！");
      this.closeDialog();
      this.$emit('onSearch');
    },
    closeDialog() {
      this.showDialog = false;
    }
  },
}
</script>

<style lang="less" scoped>
.confirmDialog {
  &:deep(.el-dialog__header) {
    padding: 0;
    height: 0;
  }

  &:deep(.el-dialog__body) {
    padding: 30px 20px !important;
    height: 190px;
  }

  .content-wrapper {
    display: flex;
    height: calc(100% - 32px);

    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }

    .title {
      font-size: 14px;
      font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 600;
      color: #222222;
      margin-bottom: 8px;
    }

    .text {
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    .warning {
      color: #ff7200;
      font-weight: bold;
    }
  }

  .btn-wrapper {
    display: flex;
    justify-content: flex-end;

    .btn {
      width: 80px;
      height: 32px;
      line-height: 30px;
      text-align: center;
      background: #ff7200;
      border-radius: 2px;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        background: rgba(255, 114, 0, 0.8);
      }

      &:last-child {
        margin-left: 24px;
      }

    }

    .cancel {
      background: #ffffff;
      border: 1px solid #cccccc;
      color: #666666;

      &:hover {
        border: 1px solid #ffdcc0;
        background: #fff7f1;
        color: #ff7200;
      }
    }
  }
}
</style>
